import { render, staticRenderFns } from "./MasterUser.vue?vue&type=template&id=2e8ea491&"
import script from "./MasterUser.vue?vue&type=script&lang=js&"
export * from "./MasterUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports